export default __webpack_public_path__ + "static/media/gilroy-medium-2-webfont.3dc171db.woff2";